import {
  ApolloClient,
  createHttpLink,
  gql,
  InMemoryCache
} from "@apollo/client";
import he from "he";
import React, { useEffect, useState } from "react";
import EditPostButton from "../../components/edit-post-button";
import SharePanel from "../../components/share";


const LavoraConNoi = (props) => {
  const {
    pageContext: {
      // id,
      postId,
      vertical,
      kind,
      // title,
      content,
      // featuredImage,
      // pageId,
    },
  } = props;

  const graphql_query = gql`
    query GET_POST($id: ID!) {
      post(id: $id, idType: DATABASE_ID) {
        id
        postId
        title
        excerpt
        uri
        link
        date
        content
        template_file
        categoria_landing_img
        categoria_landing_text
        categoria_landing_link
        video_content
        video_embedded_home
        primary_category
        primary_category_link
        categories_json_array
        featuredImage {
          node {
            link
            guid
            mediaItemUrl
            srcSet
            sizes
          }
        }
        categories {
          nodes {
            id
            name
            slug
          }
        }
        tags {
          nodes {
            id
            slug
            name
          }
        }
        author {
          node {
            name
            avatar(size: 50) {
              url
            }
            slug
            description
          }
        }
        preview {
          node {
            id
            postId
            title
            excerpt
            uri
            link
            date
            content
            template_file
            categoria_landing_img
            categoria_landing_text
            categoria_landing_link
            video_content
            video_embedded_home
            primary_category
            primary_category_link
            categories_json_array
            featuredImage {
              node {
                link
                guid
                mediaItemUrl
                srcSet
                sizes
              }
            }
            categories {
              nodes {
                id
                name
                slug
              }
            }
            tags {
              nodes {
                id
                slug
                name
              }
            }
            author {
              node {
                name
                avatar(size: 50) {
                  url
                }
                slug
                description
              }
            }
          }
        }
      }
    }
  `;

  const [allPosts, setAllPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  function getData() {
    setIsLoading(true)
    var url =
      "https://admin.startupitalia.eu/wp-json/wp/v2/posts?categoria-landing=21593&order=asc&orderby=title";
    const requestOptions = {
      credentials: "omit",
      headers: {
        accept: "application/json",
        "content-type": "application/json",
      },
      method: "GET",
      mode: "cors",
    };
    fetch(url, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        const httpLink = createHttpLink({
          uri: "https://admin.startupitalia.eu/graphql",
        });
        const client = new ApolloClient({
          link: httpLink,
          cache: new InMemoryCache(),
        });
        var promises = data.map((obj) => client.query(
          { query: graphql_query, variables: { id: obj.id } }
        ));
        Promise.all(promises.map((p) => p.catch((e) => e)))
        .then((results) => {
          console.log('results', results)
          setAllPosts(results);
          setIsLoading(false);
        })
      });

    // var postUtils = new PostsUtils({ authorId: userId }, sources, currentPage);

    // setAllPosts([]);
    // setIsLoading(true);
    // var res = postUtils.getPosts(direction);
    // res.then((res) => {
    //   setAllPosts(res.data || []);
    //   setSources(res.sources);
    //   setCurrentPage(res.currentPage);
    //   setHasNextPage(res.hasNextPage);
    //   setIsLoading(false);
    // });
  }

  // eslint-disable-next-line
  useEffect(
    () => {
      getData();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className="lavora-con-noi-main-container">
      <div
        style={{
          position: "absolute",
          top: "50%",
          right: "1%",
          zIndex: "100",
        }}
        className="div-page-edit-button"
      >
        <EditPostButton
          postId={postId}
          vertical={vertical}
          kind={kind}
        />
      </div>
      <div
        className="sfondo_landing"
        style={{
          backgroundImage: `url(${"../img/job_opportunity.jpeg"})`,
        }}
      >
        <div className="div_logo">
          <div className="lavora-con-noi-header-text">Lavora con noi</div>
        </div>
      </div>
      <div className="lavora-con-noi">
        <div
          className="lavora-con-noi-main-content"
          dangerouslySetInnerHTML={{
            __html: content.replace(/(?:\r\n|\r|\n)/g, ""),
          }}
        />
        <h2>Posizioni aperte</h2>
        {isLoading && (
          <div
            style={{
              backgroundImage: `url(${"../img/logo-startupitalia_2.gif"})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "100px",
              maxHeight: "100px",
              width: "100px",
              margin: "auto",
              marginTop: "5rem",
              marginBottom: "5rem",
            }}
          ></div>
        )}
        <div
          style={{
            marginTop: "1rem",
            marginBottom: "1rem",
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {allPosts &&
            allPosts
              .map((post) => post.data.post)
              .map((post) => {
                console.log("asdasd", post);
                // return <PostEntry key={post.id} post={post} />
                return (
                  <div
                    key={post.id}
                    className="lavora-con-noi-card"
                    style={{
                      listStyle: "none",
                    }}
                  >
                    <a className="a_black" href={post.link}>
                      <div
                        className="box_3_post"
                        style={{
                          backgroundImage: `url(${post?.featuredImage?.node?.mediaItemUrl})`,
                        }}
                      ></div>
                    </a>
                    <div className="box_content_category">
                      <a className="a_black" href={post.link}>
                        <p className="first_arg ">{post.title} </p>
                      </a>
                      <p className="first_arg_exerpt">
                        {he.decode(post.excerpt.replace(/<[^>]*>?/gm, ""))}
                      </p>
                      <a
                        href={`https://twitter.com/share?text=${post.title}&amp;url=${post.link}`}
                        target="_blank"
                        // rel="nofollow"
                        rel="noreferrer"
                      >
                        <div
                          className="share_icon_twitter"
                          style={{
                            backgroundImage:
                              "url(https://admin.startupitalia.eu/wp-content/themes/startupitalia2017/images/icon_tw_new.png)",
                          }}
                        ></div>
                      </a>
                      <a
                        href={`https://www.facebook.com/sharer.php?u=${post.link}`}
                        target="_blank"
                        // rel="nofollow"
                        rel="noreferrer"
                      >
                        <div
                          className="share_icon_facebook "
                          style={{
                            backgroundImage:
                              "url(https://admin.startupitalia.eu/wp-content/themes/startupitalia2017/images/icon_fb_new.png)",
                          }}
                        ></div>
                      </a>
                    </div>
                  </div>
                );
              })}
          <SharePanel display="none" />
        </div>
      </div>
    </div>
  );
};

export default LavoraConNoi;
